// ESM-Huelle fuer lib/scripts/components/CMP_CPagedPushPanel.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CPagedPushPanel (id)
{
    this.construct (id);

    this.name = "CPagedPushPanel";
    this.htmlType = "span";
    
    this.currentPanel = null;
    this.buttons = new Array ();
    this.panels = new Array ();
    this.pages = 0;
    this.properties =
    {
        type: "array",
        rows: 1,
        columns: 1,
        styles: {},
        nextButton:
        {
            caption:
            {
                value: "&gt;"
            },
            styles: {}
        },
        prevButton:
        {
            caption:
            {
                value: "&lt;"
            },
            styles: {}
        },
        defaultButton:
        {
            styles: {}
        }
    }
}

CPagedPushPanel.prototype = new CComponent;

CPagedPushPanel.prototype.prepare = function ()
{
    if (this.properties.type == "array")
        this.arrayFill();
    else if (this.properties.type == "xy")
        this.xyFill();
        
   this.prepared = true;
}

CPagedPushPanel.prototype.xyFill = function ()
{
    var posButtons = new Array();
    var absPos = 0;
    var pageCount = 0;
    var pageSpaceCount = this.properties.rows * this.properties.columns;
    
    for (var b = 0; b < this.buttons.length; b++)
    {
        this.buttons[b].properties = combine (this.properties.defaultButton,
            this.buttons[b].properties);
          
        absPos = (parseInt(this.buttons[b].properties.yPos) - 1) * this.properties.columns +
            (parseInt(this.buttons[b].properties.xPos - 1));

        if (this.buttons[b].properties.page > pageCount)
            pageCount = this.buttons[b].properties.page;
            
        if (typeof posButtons[this.buttons[b].properties.page - 1] == "undefined")
            posButtons[this.buttons[b].properties.page - 1] = new Array();

        posButtons[this.buttons[b].properties.page - 1][absPos] = this.buttons[b];
    }
    
    for (var p = 0; p < pageCount; p++)
    {
        this.panels[p] = this.addChild (CPushPanel);

        if (p > 0)
        {
            var prevButton = new CPushButton(this.id);
            prevButton.properties = combine (prevButton.properties,
                this.properties.defaultButton);
            prevButton.properties = combine (prevButton.properties,
                this.properties.prevButton);
            prevButton.properties.events.onMousedown = this.prevPage;
            prevButton.properties.attributes.onMousedown_parameter_0 =
                this.id;
            prevButton.properties.attributes.onMousedown_parameter_1 =
                this.panels[p].id;
            posButtons[p][0] = prevButton;
        }
        
        if (pageCount > p + 1)
        {
            var nextButton = new CPushButton(this.id);
            nextButton.properties = combine (nextButton.properties,
                this.properties.defaultButton);
            nextButton.properties = combine (nextButton.properties,
                this.properties.nextButton);
            nextButton.properties.events.onMousedown = this.nextPage;
            nextButton.properties.attributes.onMousedown_parameter_0 =
                this.id;
            nextButton.properties.attributes.onMousedown_parameter_1 =
                this.panels[p].id;
            posButtons[p][pageSpaceCount - 1] = nextButton;
        }
        
        for (var n = 0; n < pageSpaceCount; n++)
        {
            if (typeof posButtons[p][n] == "undefined")
            {
                var fillButton = new CPushButton(this.id);
                fillButton.properties = combine (fillButton.properties,
                    this.properties.defaultButton);
                fillButton.properties.styles.visibility = "hidden";
            }
        }

        this.panels[p].properties = combine (this.panels[p].properties,
            this.properties);
        this.panels[p].buttons = posButtons[p];

        if (p > 0)
        {
            this.panels[p].prevPanel = this.panels[p - 1];
            this.panels[p - 1].nextPanel = this.panels[p];
            this.panels[p].properties.styles.visibility = "hidden";
        }
        else
        {
                this.panels[p].properties.styles.visibility = "";
        }
    }

    if (typeof this.panels[0] != "undefined" && this.panels[0] != null)
        this.currentPanel = this.panels[0];

    this.pages = pageCount;
}

CPagedPushPanel.prototype.arrayFill = function ()
{
    // calculate required pages:
    var pages = 1;
    
    var pageSpaceCount = this.properties.rows * this.properties.columns;

    if (pageSpaceCount > 2 && pageSpaceCount < this.buttons.length)
        pages = Math.ceil ((this.buttons.length - 2) / (pageSpaceCount - 2));
    // ---

    var nextButton, prevButton, b = 0;
    var space = pageSpaceCount;
    var thisButtons = new Array ();
    var c = 0;
   
    for (var p = 0; p < pages; p++)
    {
        p < pages - 1 ? c = -1 : c = 0;
        if (p > 0) c -= 1;

        for (var i = 0; i < pageSpaceCount + c; i++)
        {
            if (typeof this.buttons[b] != "undefined")
            {
                this.buttons[b].properties = combine (this.properties.defaultButton,
                    this.buttons[b].properties);
                thisButtons.push (this.buttons[b]);
            }

            b++;
        }

        this.panels[p] = this.addChild (CPushPanel);

        if (p > 0)
        {
            thisButtons[0].properties.events.onMousedown = this.prevPage;
            thisButtons[0].properties.attributes.onMousedown_parameter_0 =
                this.id;
            thisButtons[0].properties.attributes.onMousedown_parameter_1 =
                this.panels[p].id;
        }
    
        if (p < pages - 1)
        {
            nextButton = new CPushButton(this.id);
            nextButton.properties = combine (nextButton.properties,
                this.properties.defaultButton);
            nextButton.properties = combine (nextButton.properties,
                this.properties.nextButton);
            nextButton.properties.events.onMousedown = this.nextPage;
            nextButton.properties.attributes.onMousedown_parameter_0 =
                this.id;
            nextButton.properties.attributes.onMousedown_parameter_1 =
                this.panels[p].id;
            thisButtons.push (nextButton);
        }
        
        this.panels[p].properties = combine (this.panels[p].properties,
            this.properties);
        this.panels[p].buttons = thisButtons;
        
        if (p > 0)
        {
            this.panels[p].prevPanel = this.panels[p - 1];
            this.panels[p - 1].nextPanel = this.panels[p];
            this.panels[p].properties.styles.visibility = "hidden";
        }
        else
        {
            this.panels[p].properties.styles.visibility = "visible";
        }

        thisButtons = new Array ();

        prevButton = new CPushButton (this.id);
        prevButton.properties = combine (prevButton.properties,
            this.properties.defaultButton);
        prevButton.properties = combine (prevButton.properties,
            this.properties.prevButton);
        thisButtons.push (prevButton);
    }
    
    if (typeof this.panels[0] != "undefined" && this.panels[0] != null)
        this.currentPanel = this.panels[0];
        
    this.pages = pages;
}

CPagedPushPanel.prototype.nextPage = function (component, parameters)
{
    var me = POS.getComponentById(parameters[0]);
    var comp = POS.getComponentById(parameters[1]);
    
    me.currentPanel = comp.nextPanel;
    
    comp.nextPanel.properties.styles.visibility = "";
    comp.nextPanel.reStyle();
    comp.properties.styles.visibility = "hidden";
    comp.reStyle();
}

CPagedPushPanel.prototype.prevPage = function (component, parameters)
{
    var me = POS.getComponentById(parameters[0]);
    var comp = POS.getComponentById(parameters[1]);
    
    me.currentPanel = comp.prevPanel;
    
    comp.prevPanel.properties.styles.visibility = "";
    comp.prevPanel.reStyle();
    comp.properties.styles.visibility = "hidden";
    comp.reStyle();
}

CPagedPushPanel.prototype.setEnabled = function(bool)
{
    if (typeof this.currentPanel != "undefined" && this.currentPanel != null)
        this.currentPanel.setEnabled(bool);
}

export { CPagedPushPanel };
